const attendeeDefault = {
  name: '',
  namebadge: '',
  email: '',
  document: '',
  mobile: '',
  address: '',
  state: '',
  city: '',
  company: '',
  role: '',
  term1: false,
  term2: false,
  term3: false,
};

const cctokenDefault = {
  number: '',
  name: '',
  country: '',
  expireAt: '',
  code: '',
  installments: 1,
};

const customerDefault = {
  name: '',
  email: '',
  mobile: '',
  document: '',
  address: '',
};

const transactionDefault = {
  promoCode: 'NOCODE',
  eventId: process.env.REACT_APP_EVENT_ID,
  eventCode: 155518,
  attendees: [],
  products: [],
  paymentType: 'credit_card',
  customer: null,
  token: '',
  installments: 1,
  utmSource: '',
  utmMedium: '',
  utmCampaign: '',
  utmTerm: '',
  utmContent: '',
};

const transactionResponseDefault = { success: false, data: null };

export {
  attendeeDefault,
  cctokenDefault,
  customerDefault,
  transactionDefault,
  transactionResponseDefault,
};
